<div *ngFor="let log of logs; let i = index">
  <div class="flex flex-row items-start w-full p-4">
    <div class="flex-shrink-0">
      <div
        [matTooltip]="log?.by"
        [ngClass]="_transloco.getActiveLang() === 'ar' ? 'me-2' : ''"
        class="h-10 w-10 rounded-full bg-accent-700 flex items-center justify-center"
      >
        <span class="text-white text-sm font-medium">
          {{ log?.by[0] | titlecase }}{{ log?.by[1] | titlecase }}
        </span>
      </div>
    </div>
    <div class="flex-grow ms-4">
      <div class="flex flex-row w-full justify-between">
        <span class="font-semibold">{{
          (log?.log_name ? log.log_name : (log?.log_name_slug | removeUnderscore)) | nwcTerminology
        }}</span>
        <span [innerHTML]="log?.created_at | dateTransform" class="text-sm text-secondary"></span>
      </div>
      <span class="mt-2 text-md text-secondary">{{ log?.log_description | nwcTerminology }}</span>
      <div
        *ngIf="
          log?.properties &&
          log.log_name_slug !== 'DELETE_TICKET' &&
          log?.log_name_slug !== 'DELETE_OBSERVATION' &&
          log?.log_name_slug !== 'default'
        "
      >
        <div *ngFor="let item of log?.properties?.old | keyvalue" class="mt-2">
          <span class="italic">{{
            item?.key | customFieldLabel: customFields | removeUnderscore | titlecase | transloco
          }}</span>
          <span class="text-secondary">{{ ' ' + ('has been updated' | transloco) }}</span>
          <div class="flex flex-row w-full items-center">
            <span class="text-secondary">{{ 'From' | transloco }}</span>

            <!-- Use a ternary operator to switch between date and non-date formatting -->
            <ng-container *ngIf="item?.key !== 'due_date'; else dateFormat">
              <ng-container
                *ngIf="
                  item?.key === 'description' ||
                    (item?.key === 'recommended_corrective_action' &&
                      getLogOld(log)?.[item?.key] != null);
                  else otherKeys
                "
              >
                <span class="mx-1 italic">
                  {{
                    stripHtmlWithSpacing((getLogOld(log)?.[item?.key] ?? '')?.toString())
                      | truncate: 30 : _transloco.getActiveLang()
                  }}
                </span>
              </ng-container>
              <ng-template #otherKeys>
                <span class="mx-1 italic" *ngIf="_transloco.getActiveLang() === 'en'">
                  {{
                    getLogOld(log)?.[item?.key] != null
                      ? getLogOld(log)?.[item?.key] === 'SAR'
                        ? ('observationType.SAR' | transloco)
                        : (getLogOld(log)?.[item?.key]?.toString()
                          | truncate: 30 : _transloco.getActiveLang()
                          | transloco)
                      : ('Empty' | transloco)
                  }}
                </span>
                <span class="mx-1 italic" *ngIf="_transloco.getActiveLang() === 'ar'">
                  {{
                    getLogOld(log)?.[item?.key] != null
                      ? getLogOld(log)?.[item?.key] === 'SAR'
                        ? ('observationType.SAR' | transloco)
                        : (getLogOld(log)?.[item?.key]?.toString()
                          | truncate: 30 : _transloco.getActiveLang()
                          | transloco)
                      : ('Empty' | transloco)
                  }}
                </span>
                <span class="mx-1 italic" *ngIf="_transloco.getActiveLang() === 'ru'">
                  {{
                    getLogOld(log)?.[item?.key] != null
                      ? getLogOld(log)?.[item?.key] === 'SAR'
                        ? ('observationType.SAR' | transloco)
                        : (getLogOld(log)?.[item?.key]?.toString()
                          | truncate: 30 : _transloco.getActiveLang()
                          | transloco)
                      : ('Empty' | transloco)
                  }}
                </span>
              </ng-template>
            </ng-container>

            <ng-template #dateFormat>
              <span
                class="mx-1 italic"
                [innerHTML]="
                  getLogOld(log)?.[item?.key] != null
                    ? (getLogOld(log)?.[item?.key] | dateTransform: 'YYYY-MM-DD hh:mm:ss')
                    : ('Empty' | transloco)
                "
              >
              </span>
            </ng-template>
            <span class="text-secondary">{{ 'To' | transloco }}</span>

            <!-- Use a ternary operator to switch between date and non-date formatting -->
            <ng-container *ngIf="item?.key !== 'due_date'; else dateFormatTo">
              <ng-container
                *ngIf="
                  item?.key === 'description' ||
                    (item?.key === 'recommended_corrective_action' &&
                      getLogAttributes(log)?.[item?.key] != null);
                  else otherKeysTo
                "
              >
                <span class="mx-1 italic"
                  >{{
                    stripHtmlWithSpacing((getLogAttributes(log)?.[item?.key] ?? '')?.toString())
                      | truncate: 30 : _transloco.getActiveLang()
                  }}
                </span>
              </ng-container>
              <ng-template #otherKeysTo>
                <span class="mx-1 italic" *ngIf="_transloco.getActiveLang() === 'en'">
                  {{
                    getLogAttributes(log)?.[item?.key] != null
                      ? getLogAttributes(log)?.[item?.key] === 'SAR'
                        ? ('observationType.SAR' | transloco)
                        : (getLogAttributes(log)?.[item?.key]?.toString()
                          | truncate: 30 : _transloco.getActiveLang()
                          | transloco)
                      : ('Empty' | transloco)
                  }}
                </span>
                <span class="mx-1 italic" *ngIf="_transloco.getActiveLang() === 'ar'">
                  {{
                    getLogAttributes(log)?.[item?.key] != null
                      ? getLogAttributes(log)?.[item?.key] === 'SAR'
                        ? ('observationType.SAR' | transloco)
                        : (getLogAttributes(log)?.[item?.key]?.toString()
                          | truncate: 30 : _transloco.getActiveLang()
                          | transloco)
                      : ('Empty' | transloco)
                  }}
                </span>
                <span class="mx-1 italic" *ngIf="_transloco.getActiveLang() === 'ru'">
                  {{
                    getLogAttributes(log)?.[item?.key] != null
                      ? getLogAttributes(log)?.[item?.key] === 'SAR'
                        ? ('observationType.SAR' | transloco)
                        : (getLogAttributes(log)?.[item?.key]?.toString()
                          | truncate: 30 : _transloco.getActiveLang()
                          | transloco)
                      : ('Empty' | transloco)
                  }}
                </span>
              </ng-template>
            </ng-container>

            <ng-template #dateFormatTo>
              <span
                class="mx-1 italic"
                [innerHTML]="
                  getLogAttributes(log)?.[item?.key] != null
                    ? (getLogAttributes(log)?.[item?.key] | dateTransform: 'YYYY-MM-DD hh:mm:ss')
                    : ('Empty' | transloco)
                "
              >
              </span>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  </div>
  <mat-divider></mat-divider>
</div>
